import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { faCalendarWeek, faChevronLeft, faChevronRight, faCircle, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar, faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import moment from "moment";
import { daysLater } from "../../commonData";
import InstructorsDropdown from "../../components/dropdowns/InstructorsDropdown";
import ClassLevelsDropdown from "../../components/dropdowns/ClassLevelsDropdown";
import DatePicker, { registerLocale } from "react-datepicker";
import pl from "date-fns/locale/pl";
import { BasicContext } from "../../App";
registerLocale("pl", pl);

const ScheduleFilters = (props) => {
    const { t } = useTranslation();
    const [showFilters, setShowFilters] = useState(false);
    const { showView } = useContext(BasicContext);
    const { setFilterDates, filterDates, initDates, selectedInstructor, setSelectedInstructor, selectedClassLvl, setSelectedClassLvl, date, setDate, daysDifference, permissions } =
        props;

    useEffect(() => {
        if (date.endDate < date.startDate) setDate({ ...date, endDate: daysLater(date.startDate, 7) });
        else {
            if (date.startDate && date.endDate) setFilterDates({ startDate: date.startDate, endDate: date.endDate });
            //else if (!date.startDate && !date.endDate) setFilterDates(initDates);
        }
        // eslint-disable-next-line
    }, [date]);

    const disableGoingPrev = () => {
        let disableBtn = false;

        if (permissions) {
            if (!permissions.checkAttendanceHistory && moment(filterDates.startDate).format("YYYY-MM-DD") <= moment().format("YYYY-MM-DD")) disableBtn = true;
        } else if (moment(filterDates.startDate).format("YYYY-MM-DD") <= moment().format("YYYY-MM-DD")) disableBtn = true;

        return disableBtn;
    };

    const addTop = () => {
        $(`#scheduleFilters`).css({ top: `${$(`.office-navbar`).outerHeight()}px` });
    };

    useEffect(() => {
        window.addEventListener("resize", addTop);
        return () => {
            window.removeEventListener("resize", addTop);
        };
    }, []);

    return (
        <Row className={showView ? "sticky-top border-bottom" : ""} id="scheduleFilters">
            {showView && (
                <Col xs={12} lg={{ span: 10, offset: 1 }} xl={{ span: 8, offset: 2 }} className="mt-3 mb-4">
                    {!showFilters ? (
                        <Row>
                            <Col>
                                <div className={`position-${selectedInstructor || selectedClassLvl ? "relative" : "static"}`}>
                                    <FontAwesomeIcon
                                        icon={faCircle}
                                        className={selectedInstructor || selectedClassLvl ? "assigned-filter-icon d-inline" : "d-none"}
                                        style={{ position: "absolute" }}
                                    />
                                    <Button variant="outline-secondary" className="mt-1 mt-lg-0 d-inline-block position-relative" size="sm" onClick={() => setShowFilters(true)}>
                                        <FontAwesomeIcon icon={faEye} className="me-2" />
                                        {t("showFilters")}
                                    </Button>
                                </div>
                            </Col>
                            <Col className="text-end">
                                {(moment().format("YYYY-MM-DD") > moment(filterDates.endDate).format("YYYY-MM-DD") ||
                                    moment().format("YYYY-MM-DD") < moment(filterDates.startDate).format("YYYY-MM-DD")) && (
                                    <Button
                                        variant="outline-secondary"
                                        className="mt-1 mt-lg-0"
                                        size="sm"
                                        onClick={() => {
                                            setFilterDates(initDates);
                                            localStorage.setItem("startDate", initDates.startDate);
                                            localStorage.setItem("endDate", initDates.endDate);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faCalendarWeek} className="me-2" />
                                        {t("schedule.thisWeek")}
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                            <Col xs={12}>
                                <Form.Label>{t("date")}</Form.Label>
                            </Col>
                            <Col xs={5} className="datepicker-sm">
                                <DatePicker
                                    autoComplete="off"
                                    selected={date.startDate}
                                    onChange={(d) => setDate({ ...date, startDate: d })}
                                    showIcon
                                    locale="pl"
                                    dateFormat="yyyy-MM-dd"
                                    icon={<FontAwesomeIcon icon={faCalendar} />}
                                    id="startDate"
                                    className="form-control form-control-sm"
                                    minDate={new Date()}
                                    popperPlacement="bottom-end"
                                />
                            </Col>
                            <Col xs={2} className="px-0 text-center pt-2">
                                {t("till")}
                            </Col>
                            <Col xs={5} className="datepicker-sm">
                                <DatePicker
                                    autoComplete="off"
                                    selected={date.endDate}
                                    onChange={(d) => setDate({ ...date, endDate: d })}
                                    showIcon
                                    locale="pl"
                                    dateFormat="yyyy-MM-dd"
                                    icon={<FontAwesomeIcon icon={faCalendar} />}
                                    id="endDate"
                                    className="form-control form-control-sm"
                                    minDate={new Date()}
                                    popperPlacement="bottom-start"
                                />
                            </Col>

                            {date.startDate && date.endDate && (
                                <Col xs={12}>
                                    <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        onClick={() => {
                                            setDate({ startDate: null, endDate: null });
                                            setFilterDates(initDates);
                                        }}
                                        className="my-2"
                                    >
                                        <FontAwesomeIcon icon={faXmark} className="me-2" />
                                        {t("clearDates")}
                                    </Button>
                                </Col>
                            )}
                            <Col xs={10} lg={4}>
                                <InstructorsDropdown
                                    id="classInstructorDropdown"
                                    value={selectedInstructor}
                                    onChange={(v) => {
                                        setSelectedInstructor(v);
                                    }}
                                    label
                                    classN="my-1"
                                    small
                                    clearable
                                />
                            </Col>
                            <Col xs={10} lg={4}>
                                <ClassLevelsDropdown
                                    id="classLevelsDropdown"
                                    value={selectedClassLvl}
                                    onChange={(v) => setSelectedClassLvl(v)}
                                    small
                                    classN="my-1 mb-2"
                                    clearable
                                />
                            </Col>

                            <Col xs={6}>
                                <Button variant="outline-secondary" size="sm" onClick={() => setShowFilters(false)}>
                                    <FontAwesomeIcon icon={faEyeSlash} className="me-2" />
                                    {t("hide")}
                                </Button>
                            </Col>
                            <Col xs={6} className="text-end">
                                <Button
                                    /* className="mb-3" */ variant="outline-secondary"
                                    size="sm"
                                    onClick={() => {
                                        setFilterDates(initDates);
                                        localStorage.setItem("startDate", initDates.startDate);
                                        localStorage.setItem("endDate", initDates.endDate);
                                        setDate({ startDate: null, endDate: null });
                                        setSelectedInstructor(null);
                                        setSelectedClassLvl(null);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faXmark} className="me-2" />
                                    <span className="d-lg-none">{t("clearFilters")}</span>
                                    <span className="d-none d-lg-inline">{t("clearAllFilters")}</span>
                                </Button>
                            </Col>
                        </Row>
                    )}
                </Col>
            )}
            <Col xs={12} lg={{ span: 10, offset: 1 }} xl={{ span: 8, offset: 2 }} className="mb-3 text-center" id="scheduleFilterDates">
                <Button
                    variant="outline-secondary"
                    disabled={disableGoingPrev()}
                    onClick={() => {
                        setFilterDates({ startDate: daysLater(filterDates.startDate, -daysDifference - 1), endDate: daysLater(filterDates.startDate, -1) });
                        localStorage.setItem("startDate", daysLater(filterDates.startDate, -daysDifference - 1));
                        localStorage.setItem("endDate", daysLater(filterDates.startDate, -1));
                    }}
                    className="float-start"
                >
                    <FontAwesomeIcon icon={faChevronLeft} />
                </Button>
                <p className="d-inline-block mb-0 align-middle">
                    {moment(filterDates.startDate).format("DD.MM")} ({moment(filterDates.startDate).format("dddd")}) – {moment(filterDates.endDate).format("DD.MM")} (
                    {moment(filterDates.endDate).format("dddd")})
                </p>
                <Button
                    variant="outline-secondary"
                    /* disabled={date.startDate && date.endDate} */
                    onClick={() => {
                        setFilterDates({ startDate: daysLater(filterDates.endDate, 1), endDate: daysLater(filterDates.endDate, daysDifference + 1) });
                        localStorage.setItem("startDate", daysLater(filterDates.endDate, 1));
                        localStorage.setItem("endDate", daysLater(filterDates.endDate, daysDifference + 1));
                    }}
                    className="float-end"
                >
                    <FontAwesomeIcon icon={faChevronRight} />
                </Button>
            </Col>
        </Row>
    );
};

export default ScheduleFilters;
